import { Component, Input, inject } from '@angular/core';
import { ConversationDetail } from '../../../../core/src/lib/interface/conversation.interface';
import { CONVERSATION_HOST_APP_INTERFACE_TOKEN } from '../../../../core/src/lib/tokens';
import { ConversationPipesModule } from '../../../../pipes/src/pipes.module';

@Component({
  selector: 'inbox-conversation-account',
  template: `
    <div class="conversation-title__wrap">
      <div class="conversation-subtitle">
        {{ subtitle | messageCodeBacktick }}
      </div>
    </div>
  `,
  styleUrls: ['./inbox-conversation-subtitle.component.scss'],
  imports: [ConversationPipesModule],
})
export class InboxConversationSubtitleAccountComponent {
  private readonly hostAppInterface = inject(CONVERSATION_HOST_APP_INTERFACE_TOKEN);

  subtitle = '';

  @Input() set conversationDetail(value: ConversationDetail | null) {
    if (!value) return;
    const titleInfo = this.hostAppInterface.getConversationTitleInfo(value);
    this.subtitle = titleInfo.subtitle ?? '';
  }
}
